import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import Dialog from '@/components/common/dialog';
import BusinessForm from './components/business-form';
import { getList as _getList, deleteItems as _deleteItems, edit, getBusinessType, importFile, getTmp, exportInfo } from '@/api/setting/business';
export default {
  name: 'setting-business',
  computed: {
    isAuth: function isAuth() {
      return this.$auth();
    },
    downLoadUrl: function downLoadUrl() {
      return exportInfo;
    }
  },
  data: function data() {
    return {
      currentTableData: [],
      loading: false,
      template: null,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      items: [],
      fullscreenLoading: false,
      searchKey: ''
    };
  },
  methods: {
    upload: function upload(file) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var formData, _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              formData = new FormData();
              formData.append('file', file);
              _this.fullscreenLoading = true;
              _context.n = 1;
              return _this.$awaitTo(importFile(formData));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              _this.fullscreenLoading = false;
              if (!err) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              _this.$message.success('操作成功');
              _this.getList();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(items) {
      this.items = items;
    },
    updateStatus: function updateStatus(item, key) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, _yield$getBusinessTyp, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$awaitTo(_this2.$$confirm("\u786E\u5B9A".concat(item.n01Available === 'Y' ? '停用' : '启用', "?")));
            case 1:
              _yield$_this2$$awaitT = _context2.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              if (!err) {
                _context2.n = 2;
                break;
              }
              item[key] = !item[key];
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return getBusinessType({
                code: item.n01Code
              });
            case 3:
              _yield$getBusinessTyp = _context2.v;
              data = _yield$getBusinessTyp.data;
              _context2.n = 4;
              return edit(_objectSpread(_objectSpread({}, data), {}, {
                n01Available: item.n01Available === 'Y' ? 'N' : 'Y'
              }));
            case 4:
              _this2.$message.success('操作成功');
              _this2.getList();
            case 5:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    deleteItems: function deleteItems(item) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$$confirm('确定删除?');
            case 1:
              _context3.n = 2;
              return _deleteItems({
                codes: item.n01Code
              });
            case 2:
              _this3.$message.success('操作成功');
              _this3.getList();
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      if (this.loading) {
        return;
      }
      this.currentPage = page;
      this.getList();
    },
    create: function create(item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$awaitTo(Dialog(BusinessForm, {
                dialog: {
                  title: item ? '编辑' : '新增',
                  width: '700px'
                },
                props: {
                  id: item ? item.n01Code : undefined,
                  onlyReady: !_this4.isAuth
                }
              }, function (template) {
                _this4.template = template;
              }));
            case 1:
              _yield$_this4$$awaitT = _context4.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 1);
              err = _yield$_this4$$awaitT2[0];
              _this4.template = null;
              if (!err) {
                _this4.getList();
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getList: function getList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_getList, data, datas, total;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this5.loading = true;
              _context5.n = 1;
              return _getList({
                length: _this5.pageSize,
                simpleSearch: _this5.searchKey,
                page: _this5.currentPage
              });
            case 1:
              _yield$_getList = _context5.v;
              data = _yield$_getList.data;
              datas = data.datas, total = data.total;
              _this5.currentTableData = datas.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  available: item.n01Available === 'Y'
                });
              });
              _this5.total = total;
              _this5.loading = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  },
  created: function created() {
    this.getList();
  }
};